import styled from "@emotion/styled";

export const OutputContainer = styled('div')`
  margin-top: 40px;

  .can-output-details {
      padding-left: 10px;
  }
`;
